import { createSelector } from 'reselect';

const getState = (state) => state?.buyItAgain;

export const buyItAgainProducts = createSelector(getState, (state) => state?.buyItAgainProducts);

export const getIsLoadingMore = createSelector(getState, (state) => state?.isLoadingMore);

export const getPageProducts = createSelector(getState, (state) => state?.pageProducts);

export const getTotalProductsCount = createSelector(getState, (state) => state?.totalProductsCount);

export const getInitialProductLoaded = createSelector(
  getState,
  (state) => state?.initialProductsLoaded
);

export const getIsLoading = createSelector(getState, (state) => state?.isLoading);

export const getBIAPageProductsIsLoading = createSelector(
  getState,
  (state) => state?.isBIAPageProductsLoading
);

export const getCD66Data = createSelector(getState, (state) => state?.cd66Data);

export const getBIAPageIsLoading = createSelector(getState, (state) => state?.isBIAPageLoading);

export const getBiaInitialApiActualProductCount = createSelector(
  getState,
  (state) => state?.initialApiProductIdCount
);

export const getBiaApiResponse = createSelector(getState, (state) => state?.biaApiResponse);
